import ApiService from 'global/utils/ApiService';
import endpointUrls from 'global/Constants/endpointUrls';
import { handleApiThenGeneric } from 'global/helperFunctions/handleApiThen';
import { IBackendSearchGeneric } from 'global/Models/globalModels';
import { AppDispatch } from 'redux/store';
import { setAllBranchWithoutSearch } from './branchReducer';

export const getAllBranchesWithoutSearch = (provinceId?: number) => async (dispatch: AppDispatch) => {
  await ApiService.post(endpointUrls.BranchesBriefListGetAll, {
    provinceId,
  })
    .then((res: IBackendSearchGeneric<any>) =>
      handleApiThenGeneric<IBackendSearchGeneric<any>, any[]>({
        res,
        notifFail: false,
        notifSuccess: false,
        onSuccessData: (data) => {
          dispatch(setAllBranchWithoutSearch(data));
        },
        onFailed: () => dispatch(setAllBranchWithoutSearch([])),
      })
    )
    .catch(() => {});
};
